import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

/**
 * Hook to detect if the current page is a lifecycle settings page
 * Returns true when on any lifecycle settings page (leads, pipeline, deals)
 */
export const useLifecyclePageDetection = () => {
  const location = useLocation();
  const [isLifecyclePage, setIsLifecyclePage] = useState(false);

  useEffect(() => {
    const lifecycleRoutes = [
      '/lifecycle-settings/Leads',
      '/lifecycle-settings/Pipeline', 
      '/lifecycle-settings/Deals',
      '/lifecycle-settings/Proposals',
      '/lifecycle-settings/Contracts'
    ];
    
    const currentPath = location.pathname;
    const isOnLifecyclePage = lifecycleRoutes.some(route => currentPath.includes(route));
    
    setIsLifecyclePage(isOnLifecyclePage);
  }, [location.pathname]);

  return isLifecyclePage;
};